export default "https://cdn-static.gokick.com/assets/d8950a20925d8040d2b2bc8b449b43040bc9b501/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";